import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import humanTime from 'flarum/common/helpers/humanTime';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
export default class SelectBestAnswerItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "post", void 0);
    _defineProperty(this, "discussion", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.post = this.attrs.post;
    this.discussion = this.attrs.discussion;
  }
  view() {
    return m("span", {
      className: "Post--BestAnswer"
    }, this.items().toArray());
  }
  getSetTime(discussion) {
    var _discussion$bestAnswe, _discussion$bestAnswe2;
    if (!((_discussion$bestAnswe = discussion.bestAnswerSetAt) != null && _discussion$bestAnswe.call(discussion))) {
      return;
    }
    const bestAnswerSetAt = (_discussion$bestAnswe2 = discussion.bestAnswerSetAt) == null ? void 0 : _discussion$bestAnswe2.call(discussion);
    if (!bestAnswerSetAt) {
      return;
    }
    return humanTime(bestAnswerSetAt);
  }
  items() {
    var _this$discussion$best, _this$discussion, _this$discussion$best2, _this$discussion2;
    const items = new ItemList();
    const label = [m(Icon, {
      name: "fas fa-check"
    }), app.translator.trans('fof-best-answer.forum.best_answer_button')];
    items.add('post', this.attrs.linkToPost ? m(Link, {
      href: app.route.post(this.attrs.post),
      "data-number": this.attrs.post.number()
    }, label) : m("span", null, label));
    const bestAnswerUser = (_this$discussion$best = (_this$discussion = this.discussion).bestAnswerUser) == null ? void 0 : _this$discussion$best.call(_this$discussion);
    bestAnswerUser && items.add('user', m("span", {
      className: "BestAnswer--User"
    }, app.translator.trans('fof-best-answer.forum.best_answer_label', {
      user: (_this$discussion$best2 = (_this$discussion2 = this.discussion).bestAnswerUser) == null ? void 0 : _this$discussion$best2.call(_this$discussion2),
      time_set: this.getSetTime(this.discussion),
      a: _ref => {
        let children = _ref.children;
        return m(Link, {
          href: app.route.user(bestAnswerUser)
        }, children);
      }
    })));
    return items;
  }
}
flarum.reg.add('fof-best-answer', 'forum/components/SelectBestAnswerItem', SelectBestAnswerItem);